export default function GameDetails() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-slate-50 p-4">
      <div className="max-w-7xl mx-auto py-12">
        <h1 className="text-4xl font-bold font-heading uppercase tracking-tight text-slate-900 mb-4">
          Game Details
        </h1>
        <p className="text-lg text-slate-600">Box score and detailed stats</p>
      </div>
    </div>
  );
}
